import { VueQueryPlugin, QueryClient } from '@tanstack/vue-query';
import { VueQueryDevtools } from '@tanstack/vue-query-devtools';

import { millisecondsIn } from '@nova/core';

export const QUERY_DEFAULTS = {
  staleTime: 5 * millisecondsIn.minute,
  gcTime: 10 * millisecondsIn.minute,
  retryDelay: 1000,
  retryAttempts: 3
};

function isUnauthorizedError(error) {
  return error?.response?.status === 401;
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: QUERY_DEFAULTS.staleTime,
      gcTime: QUERY_DEFAULTS.gcTime,
      retryDelay: QUERY_DEFAULTS.retryDelay,
      refetchOnWindowFocus: 'always',
      retry: (failureCount, error) => {
        if (isUnauthorizedError(error)) {
          return false;
        }
        return failureCount < QUERY_DEFAULTS.retryAttempts;
      }
    },
    mutations: { retry: 0 }
  }
});

function installVueQuery(app) {
  /** @type {import('@tanstack/vue-query').VueQueryPluginOptions} */
  const options = { queryClient };
  app.use(VueQueryPlugin, options);

  // Mount devtools in dev only
  if (import.meta.env.DEV) {
    app.component('VueQueryDevtools', VueQueryDevtools);
  }

  return queryClient;
}

class VueQueryPluginInitializer {
  static init(app) {
    installVueQuery(app);
  }
}

export default VueQueryPluginInitializer;
